import { getDynamicSemanticToken } from '../../../DesignSystem';
import { getDefaultZoomUI } from '../../../ThemeProvider';
export function getDynamicThemeToken(theme) {
    // Get dynamic semantic design token,
    // which can automatically switch between light and dark content
    const semantic = getDynamicSemanticToken(theme);
    const { typography, shadow, zIndex } = theme?.zoomUI ?? getDefaultZoomUI();
    return {
        zIndex: zIndex.Dropdown,
        padding: {
            popup: '8px',
            menuItem: '6px 8px',
        },
        fontSize: 14,
        fontFamily: typography.fontFamily,
        lineHeight: '20px',
        boxShadow: shadow.md,
        disabledOverlay: semantic.state.inactive,
        borderRadius: {
            menuItem: '4px',
        },
        color: {
            default: semantic.text.stronger.neutral,
            primary: semantic.text.primary,
            disabled: semantic.text.stronger.neutral,
            active: semantic.text.stronger.neutral,
            danger: semantic.text.error,
        },
        background: {
            default: semantic.fill.default,
            primary: semantic.fill.primary,
            hover: semantic.state.subtle.neutral.hover,
            press: semantic.state.subtle.neutral.press,
            disabled: semantic.fill.default,
            active: semantic.state.subtle.neutral.hover,
        },
        border: {
            primary: semantic.border.primary,
        },
        paper: {
            borderColor: semantic.border.subtle.neutral,
            backgroundColor: semantic.fill.default,
            boxShadow: shadow.sm,
            textColor: semantic.text.stronger.neutral,
        },
        title: {
            color: semantic.text.neutral,
        },
    };
}
